import { useEffect, useRef, useState } from "react";

export const AnimateIn = ({
  children,
  variant = "fade",
  delay = 0,
  once = true,
  className = "",
  as: Tag = "div",
  ...rest
}) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setTimeout(() => setInView(true), delay);
            if (once) obs.unobserve(el);
          } else if (!once) {
            setInView(false);
          }
        });
      },
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [delay, once]);

  const variantCls = {
    fade: "wc-fade-in",
    "slide-left": "wc-slide-left",
    "slide-right": "wc-slide-right",
    slam: "wc-slam-down",
  }[variant];

  return (
    <Tag
      ref={ref}
      className={`${variantCls} ${inView ? "wc-in" : ""} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default AnimateIn;
